<ng-container *transloco="let t;">

  <p-dialog header="{{ t('partials.timezone_selector.header') }}" [(visible)]="visible" [draggable]="false" [resizable]="false" modal="true" appendTo="body" [style]="{width: '50vw'}" (onHide)="onClose()">

    <p>{{ t('partials.timezone_selector.please_select_timezone') }}</p>
    <form *ngIf="loading !== true" novalidate>

      <div class="p-grid">

        <div class="p-col-6">
          <div class="selector" (click)="setMode(TimezoneModes.Procedure)" [ngClass]="{'active': form.get('mode').value === TimezoneModes.Procedure}">
            <p class="icon"><fa-icon [icon]="faCalendarAlt"></fa-icon></p>
            <p class="label">{{ t('partials.timezone_selector.procedure') }}</p>
            <p class="timezone">{{ procedureTimezoneName }}<br><span class="offset">(GMT{{ procedureTimezoneOffset }})</span></p>
          </div>
        </div>

        <div class="p-col-6">
          <div class="selector" (click)="setMode(TimezoneModes.Own)" [ngClass]="{'active': form.get('mode').value === TimezoneModes.Own}">
            <p class="icon"><fa-icon [icon]="faPortrait"></fa-icon></p>
            <p class="label">{{ t('partials.timezone_selector.own') }}</p>
            <p-dropdown
              [formControl]="form.get('timezone')"
              id="select_timezone"
              [options]="optionsTimezones"
              [optionLabel]="'zone_name'"
              [dataKey]="'zone_name'"
              [placeholder]="t('common.labels.timezone')"
              [filter]="true"
              [resetFilterOnHide]="true"
              [showClear]="false"
              [appendTo]="'body'"
            ></p-dropdown>
          </div>
        </div>

      </div>
    </form>

    <p-footer>
      <button pButton (click)="onSubmit()" type="submit" [loading]="saving" [label]="t('common.labels.ok')"></button>
    </p-footer>

  </p-dialog>

</ng-container>
